import { render } from "./filter_all.svg?vue&type=template&id=40fd14ce?inline"
const script = {}
script.render = render

export default script